import { render, staticRenderFns } from "./UpperBar.vue?vue&type=template&id=4511d1fa&scoped=true&"
import script from "./UpperBar.vue?vue&type=script&lang=js&"
export * from "./UpperBar.vue?vue&type=script&lang=js&"
import style0 from "./UpperBar.vue?vue&type=style&index=0&id=4511d1fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4511d1fa",
  null
  
)

export default component.exports